<div class="wrapper" [ngClass]="showSearch?'little-page':'lower'">
    <search-with-select [showCheckbox]="showCheckbox" *ngIf="showSearch" [loadingVideos]="loadingVideos" class="search"
        (showBlockedChanged)="showBlockedChangedEvent()">
    </search-with-select>
</div>